


/* ------------------------------------------------------- INITIALIZE APP --- */
whenVendorReady(function() {
  initializePageScript()
});

function initializePageScript() {
  initCalc();
  initMap();
  initSearchform();
}












/* -------------------------------------------------------- MORTGAGE CALC --- */

function initCalc() {
  initCalcAmount();
  initCalcPeriod();
  updateResult();
  addAmountInputInteractions();
  addPeriodInputInteractions();
}

function initCalcAmount() {
  const val = Number(calcPreset.loanval);
  $('#calcAmount').val(val + ' zł').data('val', val);
  $('#sliderAmount').slider({
    orientation: "horizontal",
    range: 'min',
    min: Number(calcPreset.minval),
    max: Number(calcPreset.maxval),
    value: Number(calcPreset.loanval),
    step: 1000,
    slide: function( event, ui ) {
      $('#calcAmount').val(ui.value + ' zł').data('val', ui.value);
    },
    change: function( event, ui ) {
      calcDelayedUpdate();
    }
  });
}

function initCalcPeriod() {
  const months = Number(calcPreset.months);
  $('#calcPeriod').val(getMonthsLabel(months)).data('val', months);

  $('#sliderPeriod').slider({
    orientation: "horizontal",
    range: 'min',
    min: Number(calcPreset.minmonths),
    max: Number(calcPreset.maxmonths),
    value: Number(calcPreset.months),
    step: 12,
    slide: function( event, ui ) {
      $('#calcPeriod').val(getMonthsLabel(ui.value)).data('val', ui.value);
    },
    change: function( event, ui ) {
      calcDelayedUpdate();
    }
  });
}

function getMonthsLabel(months) {
  return months/12 + ' lat';
}

var calcTimeout = null;
function calcDelayedUpdate() {
  if (calcTimeout !== null) {
    clearTimeout(calcTimeout);
    calcTimeout = null;
  }
  calcTimeout = setTimeout(function() {
    updateResult();
  }, 100);
}

function updateResult() {
  const amount = $('#calcAmount').data('val');
  const period = $('#calcPeriod').data('val');

  $.ajax({
    method: "POST",
    url: "/kalkulator/oblicz-rate",
    data: {
      presetId: 1,
      period: period,
      value: amount
    }
  })
  .done(function(res) {
    $('#calcResult').text(res.result + ' zł');
  });
}

/**
 * Catching events for amount input
 */
function addAmountInputInteractions() {
  $('#calcAmount').click(function() {
    $(this).prop('value', Number(filterDigits($(this).val())));
  });
  $('#calcAmount').keyup(function() {
    var val = Number(filterDigits($(this).val()));
    if (val !== NaN) {
      calcUpdateAmount(val, false);
    }
  });
  $('#calcAmount').change(function() {
    var val = Number(filterDigits($(this).val()));
    if (val !== NaN) {
      calcUpdateAmount(val);
    }
  });
}

/**
 * Catching events for period input
 */
function addPeriodInputInteractions() {
  $('#calcPeriod').click(function() {
    $(this).prop('value', Number(filterDigits($(this).val())));
  });
  $('#calcPeriod').keyup(function() {
    var val = Number(filterDigits($(this).val()));
    if (val !== NaN) {
      calcUpdatePeriod(val, false);
    }
  });
  $('#calcPeriod').change(function() {
    var val = Number(filterDigits($(this).val()));
    if (val !== NaN) {
      calcUpdatePeriod(val);
    }
  });
}

/**
 * Change amount slider and input
 * @param {Number} amount Amount
 * @param {Boolean} refreshInput If false not updating value of input
 */
function calcUpdateAmount(amount, refreshInput) {
  refreshInput = refreshInput !== undefined ? refreshInput : true;
  const max = $('#sliderAmount').slider('option', 'max');
  const min = $('#sliderAmount').slider('option', 'min');
  amount = amount >= min ? amount : min;
  amount = amount <= max ? amount : max;

  $('#sliderAmount').slider('value', amount);
  if (refreshInput) {
    $('#calcAmount').val(amount + ' zł').data('val', amount);
  }
}

/**
 * Change period slider and input
 * @param {Number} period Period in months
 * @param {Boolean} refreshInput If false not updating value of input
 */
function calcUpdatePeriod(period, refreshInput) {
  period = period * 12;
  refreshInput = refreshInput !== undefined ? refreshInput : true;
  const max = $('#sliderPeriod').slider('option', 'max');
  const min = $('#sliderPeriod').slider('option', 'min');
  period = period >= min ? period : min;
  period = period <= max ? period : max;

  $('#sliderPeriod').slider('value', period);
  if (refreshInput) {
    $('#calcPeriod').val(getMonthsLabel(period)).data('val', period);
  }
}

/**
 * Remove all characrers except of digits
 * @param {String} txt String to clear
 */
function filterDigits(txt) {
  return (String(txt)).replace(/\D+/g, '');
}